<template>
  <component
    :is="href && !disabled && !isSelected ? 'a' : 'button'"
    :href="href && !isSelected ? href : undefined"
    :title="label"
    :class="[
      'flex w-full rounded-md p-2 transition-colors',
      'relative focus:outline-none',
      isSelected ? 'bg-[#005EDA] text-white' : inactiveClasses,
      disabled ? 'cursor-not-allowed opacity-50' : 'cursor-pointer',
      expanded ? 'items-center justify-start' : 'items-center justify-center'
    ]"
    @click="onClick"
  >
    <div :class="['flex items-center justify-center']">
      <slot name="icon" class="cursor-pointer">
        <ItemIcon :id="id" :isSelected="isSelected" />
      </slot>
    </div>

    <span
      v-if="expanded || position === 'top' || position === 'bottom' || isMobileNav"
      :class="[
        'whitespace-nowrap text-sm',
        expanded && 'ml-3',
        expanded && !isMobileNav ? 'transition-opacity duration-300 ease-in-out' : ''
      ]"
    >
      {{ label }}
    </span>
  </component>
</template>

<script lang="ts">
import { defineComponent, toRefs } from 'vue'
import { type Position } from '../types/NavigationPane'
import ItemIcon from './ItemIcon.vue'

export default defineComponent({
  name: 'NavigationPaneItem',
  components: {
    ItemIcon
  },
  props: {
    id: {
      type: String,
      required: true
    },
    label: {
      type: String,
      required: true
    },
    href: {
      type: String,
      default: undefined
    },
    expanded: {
      type: Boolean,
      default: false
    },
    isSelected: {
      type: Boolean,
      default: false
    },
    position: {
      type: String as () => Position,
      default: 'left'
    },
    disabled: {
      type: Boolean,
      default: false
    },
    isMobileNav: {
      type: Boolean,
      default: false
    }
  },
  emits: ['click'],
  setup(props, { emit }) {
    const { disabled, id, isSelected } = toRefs(props)
    const onClick = () => {
      if (!disabled.value && !isSelected.value) {
        emit('click')
      }
    }

    const activeClasses = 'bg-white/20 text-white'
    const inactiveClasses = 'hover:bg-white/10 text-white'
    return {
      onClick,
      activeClasses,
      inactiveClasses
    }
  }
})
</script>
